const impressions = {
  reduxBufferSize: 10,
  postBatchSize: 50,
  impressionTypes: {
    restaurant: 'restaurant',
    dish: 'dish',
    brand: 'brand',
    product: 'product',
    review: 'review'
  },
  pages: {
    brand: 'brand',
    dish: 'dish',
    collection: 'collection',
    dishes: 'dishes',
    explore: 'explore',
    feed: 'feed',
    hashtag: 'hashtag',
    near: 'near',
    listing: 'listing',
    product: 'product',
    products: 'products',
    restaurant: 'restaurant',
    review: 'review',
    search: 'search',
    user: 'user'
  }
}

export default impressions
